import { deskCard, deskEyebrow, deskMuted } from "./salesDeskStyles";
import type { SalesDeskInventoryModel } from "./salesDeskInventoryModel";

const money = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export function SalesDeskInventoryModels({
  models,
  sourceLabel,
}: {
  models: SalesDeskInventoryModel[];
  sourceLabel: string;
}) {
  if (models.length === 0) return null;
  return (
    <section className="mt-10">
      <p className={deskEyebrow}>Models</p>
      <h2 className="mt-2 text-[24px] font-semibold tracking-[-0.5px]">The building, then the ones like it.</h2>
      <p className={`mt-2 max-w-[40rem] ${deskMuted}`}>
        Each order is one building. The model above it is the configuration this organization can later adopt as standard stock. {sourceLabel}.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-4">
        {models.map((model) => (
          <article key={model.key} className={deskCard}>
            <p className="inline-flex rounded-full bg-[#eef1e7] px-2.5 py-1 text-[11px] font-semibold text-[#164b43] dark:bg-zinc-800 dark:text-emerald-200">
              {model.standard ? "Standard" : "Standard not chosen"}
            </p>
            <h3 className="mt-3 text-[21px] font-semibold capitalize">{model.label}</h3>
            <p className={`mt-1 ${deskMuted}`}>{model.supplier}</p>
            <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {model.pieces.map((piece) => (
                <div key={piece.id} className="rounded-lg border border-[#dce3dc] p-3 dark:border-zinc-700">
                  <p className="text-[11px] font-semibold uppercase tracking-[1px] text-[#687772] dark:text-zinc-400">This order</p>
                  <p className="mt-1 text-sm font-semibold">
                    {[piece.sidingColor, piece.roof].filter(Boolean).join(" · ") || piece.label}
                  </p>
                  {piece.siding ? <p className={`mt-1 ${deskMuted}`}>{piece.siding}</p> : null}
                  {piece.floor ? <p className={`mt-1 ${deskMuted}`}>{piece.floor}</p> : null}
                  <p className="mt-2 text-sm">{piece.price == null ? "Price not on the order" : money.format(piece.price)}</p>
                  <p className="mt-1 break-all text-xs text-[#687772] dark:text-zinc-400">{piece.id}</p>
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
